import makeAction from "./../../libs/actions";

export const fetchParticipantsAction = makeAction(
  "participants/FETCH_PARTICIPANTS"
);
export const fetchParticipantBySlugAction = makeAction(
  "participants/FETCH_PARTICIPANT_BY_SLUG"
);
